module.exports = __webpack_public_path__ + "img/bird-1-left.8f868a29.png";